class MetricSummary {
  constructor(container, name, data, selected) {
    this.container = jQuery(container);
    this.name = name;
    this.data = data;
    this.hasAverage = !!data.average;
    this.showTotal = true;

    this.createElement(selected);
    this.addClickListeners();
  }

  createElement(selected) {
    let element = (this.element = {});
    element.container = jQuery("<div>", { class: "report-metric-container" });
    element.label = jQuery("<label>", { class: `report-metric ${selected ? "active" : ""}` });
    element.radio = jQuery("<input>", {
      type: "radio",
      checked: selected,
      name: "report-metric",
      value: this.name,
      "data-behaviour": "refresh-graph",
    });
    element.value = jQuery("<div>", { class: "report-metric-value" });
    element.title = jQuery("<div>", { class: "report-metric-title" });
    element.toggler = jQuery("<div>", { class: "report-metric-toggler" });

    element.container.append(element.label.append(element.radio).append(element.value).append(element.title));

    if (this.data.description) {
      element.tooltip = jQuery("<sp-icon>", {
        name: "info",
        class: "report-metric-tooltip",
        "data-tooltip": this.data.description,
      });
      element.label.append(element.tooltip);
    }

    if (this.hasAverage) {
      element.container.append(element.toggler);
    }

    this.container.append(element.container);

    this.populateSummary(this.showTotal);
  }

  addClickListeners() {
    this.element.radio.on("click", (e) => {
      if (this.hasAverage && this.element.label.hasClass("active")) {
        this.showTotal = !this.showTotal;
        this.populateSummary(this.showTotal);
      }

      this.container.find(".active").removeClass("active");
      this.element.label.addClass("active");
    });
  }

  populateSummary(showTotal) {
    if (showTotal) {
      this.element.value.text(this.format(this.data.value, this.data.type));
      this.element.title.text(this.data.title);
      this.element.toggler.text("( click to show average )");
    } else {
      this.element.value.text(this.format(this.data.average, this.data.type));
      this.element.title.text(this.data.title + " / " + this.data.average_type);
      this.element.toggler.text("( click to show total )");
    }
  }

  format(item, type) {
    switch (type) {
      case "time":
        item = this.formatTime(item);
        break;
      case "int":
        item = this.formatNumber(item);
        break;
      case "percent":
        item = this.formatPercent(item);
        break;
    }
    return item;
  }

  formatTime(seconds) {
    var minutes = Math.floor(seconds / 60);
    var seconds = seconds % 60;

    return minutes + "m " + seconds + "s";
  }

  formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatPercent(percent) {
    return (percent * 100).toFixed(1) + "%";
  }
}

window.MetricSummary = MetricSummary;
